import { render, staticRenderFns } from "./dicSelector.vue?vue&type=template&id=f9d058c8&"
import script from "./dicSelector.vue?vue&type=script&lang=js&"
export * from "./dicSelector.vue?vue&type=script&lang=js&"
import style0 from "./dicSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports